const requiredValidator = (value = '', { label = '' }) => {
    if (value !== undefined && value !== null && value !== '') return ''
    return `${label || 'This'} field is required`
}

const maxLengthValidator = (value = '', { message = '', maxLength = 20 }) => {
    if (value.length > maxLength) {
        return message || `Maximum ${maxLength} characters allowed`
    }
}

const phoneNumberValidator = (value = '', { message = '' }) => {
    const phoneNumberRegex = /[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{3,5}$/;
    if (value && !phoneNumberRegex.test(value)) {
        return message || 'Invalid Phone Number';
    }
}

const emailValidator = (value = '', { message = '' }) => {
    const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    if (value && !emailRegex.test(value)) {
        return message || 'Invalid Email';
    }
}

const IS_REQUIRED = { required: { validator: requiredValidator } }

const IS_MAX_LENGTH = { maxLength: { validator: maxLengthValidator, maxLength: 20 } }

const IS_PHONE_NUMBER = { phoneNumber: { validator: phoneNumberValidator } }

const IS_EMAIL = { email: { validator: emailValidator } }

export { IS_REQUIRED, IS_MAX_LENGTH, IS_PHONE_NUMBER, IS_EMAIL }
